<p-avatar shape="circle" size="large">
    <i *ngIf = "icon" class="material-icons-outlined">{{icon}}</i>
    <i *ngIf = "flatIcon" class="flaticon {{flatIcon}}"></i>
</p-avatar>
